export default {
  HIDE_MOBILE_BOTTOM_NAVIGATION: (state) => {
    state.showMobileBottomNavigation = false;
  },
  SHOW_MOBILE_BOTTOM_NAVIGATION: (state) => {
    state.showMobileBottomNavigation = true;
  },
};
